// This file includes components used by our client facing UI.
// Please lazily load large components.

import { BudgetDisplayPill } from "~/src/components/BudgetDisplayPill"
import { ContactUs } from "~/src/components/ContactUs"
import { DashboardDebugBox } from "~/src/components/DashboardDebugBox"
import { DisplayTagList } from "~/src/components/DisplayTagList"
import { DropshipEditor } from "~/src/components/DropshipEditor/DropshipEditor"
import { ErrorPage } from "~/src/components/ErrorPage"
import { NavbarProjectFolder } from "~/src/components/NavbarProjectFolder"
import { OrderRecipientDelivery } from "~/src/components/OrderRecipientDelivery"
import { ProductDetail } from "~/src/components/ProductDetail"
import { ReactionStatistics } from "~/src/components/ReactionStatistics"
import { RequestCart } from "~/src/components/RequestCart"
import { SelectionItemWarnings } from "~/src/components/SelectionItemWarnings"
import { SignIn } from "~/src/components/SignIn"
import { SolutionInstanceToggle } from "~/src/components/Solutions/SolutionInstanceToggle"
import { Spreadsheet } from "~/src/components/Spreadsheet/Spreadsheet"
import { StorefrontOrderHistoryControls } from "~/src/components/StorefrontOrderHistoryControls"
import { StoreKitInstanceForm } from "~/src/components/StoreKitInstances/StoreKitInstanceForm"
import { TeamForm } from "~/src/components/Teams/TeamForm"
import { TeamsTable } from "~/src/components/Teams/TeamsTable"
import { ThankYouNoteConfirmation } from "~/src/components/ThankYouNoteConfirmation"
import { ThankYouNoteLanding } from "~/src/components/ThankYouNoteLanding"
import { ThankYouNoteMessageCarousel } from "~/src/components/ThankYouNoteMessageCarousel"
import { ThankYouNotesIndex } from "~/src/components/ThankYouNotesIndex"
import { registerComponents } from "~/src/lib/reactComponentRegistry"

registerComponents({
  BudgetDisplayPill,
  ContactUs,
  Controller: import("~/src/components/Controller/Controller"),
  CustomTraySolutionForm: import("~/src/components/Solutions/CustomTraySolutionForm"),
  CustomTraySolutionSelectorForm: import("~/src/components/Solutions/CustomTraySolutionSelectorForm"),
  DashboardDebugBox,
  DashboardToaster: import("~/src/components/DashboardToaster"),
  DisplayTagList,
  DropshipEditor,
  ErrorPage,
  MessageContactForm: import("~/src/components/MessageContactForm"),
  NavbarProjectFolder,
  OrderRecipientDelivery,
  ProductDetail,
  ReactionStatistics,
  RequestCart,
  SignIn,
  SolutionInstanceToggle,
  Spreadsheet,
  StorefrontOrderHistoryControls,
  StoreKitInstanceForm,
  SelectionItemWarnings,
  StripeFieldSet: import("~/src/components/StripeFieldSet"),
  TeamForm,
  TeamsTable,
  ThankYouNoteConfirmation,
  ThankYouNoteLanding,
  ThankYouNoteMessageCarousel,
  ThankYouNotesIndex,
})
